import React from 'react';
import PropTypes from 'prop-types';
import BrowseFilterDisplay from '../UI/BrowseFilterDisplay';

ActiveFilters.propTypes = {
	activeCategories: PropTypes.array,
	removeFilter: PropTypes.func,
	changeExclusion: PropTypes.func,
};

function ActiveFilters({ activeCategories, removeFilter, changeExclusion }) {
	return (
		<div className="active-category-filters">
			{activeCategories.map((category, idx) => (
				<div className="tag-root relative" key={idx}>
					<BrowseFilterDisplay
						label={category.label}
						value={category.value}
						isExclusion={category.isExclusion}
						idx={idx}
						isEditable={true}
						removeFilter={removeFilter}
						changeExclusion={changeExclusion}
					/>
				</div>
			))}
		</div>
	);
}

export default ActiveFilters;
